"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Models_1 = require("ContentTokens/Models");
var typeUtils_1 = require("ContentTokens/Models/inputs/typeUtils");
var Types_1 = require("ContentTokens/Models/inputs/Types");
var SubstitutionTokenFactory_1 = __importDefault(require("Tokens/SubstitutionTokenFactory"));
var ButtonTokenReplacer = (function () {
    function ButtonTokenReplacer() {
    }
    ButtonTokenReplacer.prototype.supports = function (contentToken) {
        return contentToken.type == "block" && contentToken.subType == Models_1.BlockType.Button;
    };
    ButtonTokenReplacer.prototype.extractSubstitutionToken = function (buttonToken) {
        return (0, typeUtils_1.isTokenInput)(buttonToken.href)
            ? {
                index: buttonToken.href.substitutionToken ? buttonToken.href.substitutionToken.id : buttonToken.href.name,
                name: buttonToken.href.label,
                apiName: buttonToken.href.name,
            }
            : undefined;
    };
    ButtonTokenReplacer.prototype.createReplacement = function (buttonToken, tokenToInsert) {
        if ((0, typeUtils_1.isTokenInput)(buttonToken.href)) {
            return __assign(__assign({}, buttonToken), { href: new Types_1.TokenInput(tokenToInsert.apiName, tokenToInsert.name, SubstitutionTokenFactory_1.default.fromLegacyApiToken(tokenToInsert)) });
        }
        return buttonToken;
    };
    return ButtonTokenReplacer;
}());
exports.default = ButtonTokenReplacer;
